import React from 'react';
import {getIcon} from "../helpers";
import Select from 'react-select';

class FilterDropDown extends React.Component {


    render() {
        return (
            <div className="pt-3">
                <Select
                    value={this.props.active_category}
                    onChange={(value) => this.props.filterByCategory(value)}
                    options={this.props.categories}
                    placeholder={ __("Filter by Category") }
                    className="fw-medium"
                />
            </div>
        )
    }

}

export default FilterDropDown;
